import  request  from '../../Interceptor/request.js'

//查询缴费信息
export function information() {
    return request({
        url: '/paymentInfo/list',
        method: 'get'
    })
}

//期数具体数据
export function informationDel(data){
    return request({
        url:'/paymentInfo',
        method: 'delete',
        data:data
    })
}
